<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="12" class="mb-5">
              <b-form-file
                v-model="uploadedCsv"
                :state="Boolean(uploadedCsv)"
                :required="true"
                accept=".csv"
                :placeholder="$t('page.generic.placeHolders.fileInput')"
                :drop-placeholder="$t('page.generic.placeHolders.dropFile')"
                aria-describedby="cvs-help-block"
              >
              </b-form-file>
              <p class="mt-3">
                {{ $t("procedures.fileUploadHelper.mainDescription") }}
                <ul class="mt-1">
                  <li>
                    {{ $t("procedures.fileUploadHelper.procedureCode") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.procedureLabel") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.sourceCode") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.procedureDescription") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.procedureTypeCode") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.enabled") }}
                  </li>
                  <li>
                    {{ $t("procedures.fileUploadHelper.modelCodeList") }}
                  </li>
                </ul>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createProcedure">
                {{ $t('actions.upload') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'procedureRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import ProcedureService from "@/services/ProcedureService";

const procedureService = ProcedureService.build();

export default {
  name: 'ProcedureCsv',
  inheritAttrs: false,
  components: {
    PageTitle,
  },
  data() {
    return {
      uploadedCsv: null,
      errors: []
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
  },
  methods: {
    async createProcedure() {
      if(this.uploadedCsv === null) {
        miniToastr.error('File csv non caricato');
        return
      }
      try {
        await procedureService.createCsv(this.uploadedCsv);
        this.$router.push({name: `procedureListRoute`})
      } catch (exception) {
        this.errors = exception;
        miniToastr.error(exception.message);
      }
    },
  }
}
</script>

